import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const externalEmployerCrudActionTypes = generateEntityCrudActionTypes('externalEmployer')

export default { ...externalEmployerCrudActionTypes }
